import { cliengoQueries } from "../hooks/useCliengoQuery.js";
export class PermissionsService {
  user;
  permissions;
  constructor(user){
    this.permissions = new Set(user.permissions);
    this.user = user;
  }
  /** userfull for check if all permissions are present */ hasPermission(required) {
    return required.every((p)=>this.permissions.has(p));
  }
  /** userfull for check if ONE of the permissions is present */ hasOneOf(required) {
    return required.some((p)=>this.permissions.has(p));
  }
  isAdmin() {
    return this.hasOneOf([
      'admin',
      'reseller_admin'
    ]);
  }
  getPermissions() {
    return this.permissions;
  }
  isSuperUser() {
    return this.user.isSuperUser;
  }
}
/**
 * Hook to get the PermissionsService instance.
 * 
 * @returns {PermissionsService} The PermissionsService instance.
 * 
 * @description
 * This hook typically returns a populated PermissionsService instance. 
 * Due to React Query's caching mechanism, the MFE host has usually 
 * already fetched the user data, so it will use the cached data and 
 * "data" will rarely, if ever, be undefined.
 * 
 * The conditional check and type casting are primarily for TypeScript's 
 * benefit, ensuring the correct type is returned. In practice, the 
 * PermissionsService will almost always be instantiated with valid user data.
 */ export const usePermissionsService = ()=>{
  const { data, status } = cliengoQueries.user();
  let service = {};
  if (data && status === 'success') {
    service = new PermissionsService(data);
  }
  return service;
};
export const getPermissionsService = (user)=>{
  return new PermissionsService(user);
};
//# sourceMappingURL=permissions.service.js.map